/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import ChartFocusDialog from '../RelatorioDigitacao/ChartFocusDialog';
import { ChartCard, FOCUS_CHART_HEIGHT } from './chartShared';
import DistribuicaoChart from './DistribuicaoChart';
import EvolucaoChart from './EvolucaoChart';

const ChartsRow = ({ evolucaoMensal, distribuicao, totalGasto, loading }) => {
  const [focusEvolucao, setFocusEvolucao] = useState(false);
  const [focusDistribuicao, setFocusDistribuicao] = useState(false);

  return (
    <>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, lg: 6 }}>
          <ChartCard title="Evolução Mensal" onExpand={() => setFocusEvolucao(true)}>
            <EvolucaoChart items={evolucaoMensal} loading={loading} />
          </ChartCard>
        </Grid>
        <Grid size={{ xs: 12, lg: 6 }}>
          <ChartCard
            title="Distribuição por Categoria"
            onExpand={() => setFocusDistribuicao(true)}
            contentSx={{ position: 'relative', overflow: 'visible' }}
          >
            <DistribuicaoChart
              items={distribuicao}
              loading={loading}
              totalGasto={totalGasto}
            />
          </ChartCard>
        </Grid>
      </Grid>

      <ChartFocusDialog
        open={focusEvolucao}
        title="Evolução Mensal"
        onClose={() => setFocusEvolucao(false)}
      >
        <EvolucaoChart items={evolucaoMensal} loading={loading} height={FOCUS_CHART_HEIGHT} />
      </ChartFocusDialog>

      <ChartFocusDialog
        open={focusDistribuicao}
        title="Distribuição por Categoria"
        onClose={() => setFocusDistribuicao(false)}
      >
        <DistribuicaoChart
          items={distribuicao}
          loading={loading}
          totalGasto={totalGasto}
          height={FOCUS_CHART_HEIGHT}
        />
      </ChartFocusDialog>
    </>
  );
};

ChartsRow.propTypes = {
  evolucaoMensal: PropTypes.array,
  distribuicao: PropTypes.array,
  totalGasto: PropTypes.number,
  loading: PropTypes.bool,
};

ChartsRow.defaultProps = {
  evolucaoMensal: [],
  distribuicao: [],
  totalGasto: 0,
  loading: false,
};

export default ChartsRow;
